






import { Component, Vue, Prop } from 'vue-property-decorator'
import { TreeItem } from '../model/filetree'

import FileTreeNode from './FileTreeNode.vue'

@Component({
  components: {
    FileTreeNode
  }
})
export default class FileTree extends Vue {
  @Prop() tree!: TreeItem[]

  get root () {
    return {
      type: 'root',
      name: 'Package',
      tree: this.tree
    }
  }
}
